import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const supportedLanguages = ["pt", "en", "es"];
const fallbackLanguage = "en";
const savedLanguageKey = "soup_selected_language";
const publicUrl = process.env.PUBLIC_URL || "";

const normalizeLanguage = (language) => {
  const baseLanguage = (language || "").split("-")[0].toLowerCase();
  return supportedLanguages.includes(baseLanguage)
    ? baseLanguage
    : fallbackLanguage;
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return fallbackLanguage;
  }

  const savedLanguage = window.localStorage.getItem(savedLanguageKey);

  if (savedLanguage) {
    return normalizeLanguage(savedLanguage);
  }

  const browserLanguage =
    window.navigator.languages?.[0] ||
    window.navigator.language ||
    fallbackLanguage;

  return normalizeLanguage(browserLanguage);
};

const staticBasePath =
  process.env.REACT_APP_IS_PRODUCTION === "TRUE" ? "/static" : "";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: fallbackLanguage,
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    backend: {
      loadPath: `${publicUrl}${staticBasePath}/locales/{{lng}}/translation.json`,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export { supportedLanguages, fallbackLanguage, savedLanguageKey };
export default i18n;
